// import { sendVerificationCode } from "@/api/LoginSignup";
// import React, { useEffect, useState } from "react";
// import Modal from "react-bootstrap/Modal";

// const VerifyPhoneModal = ({ show, handleClose,phoneNumber }) => {
//     const [resp,setResp] = useState({});

//     const verificationCode = async() =>{
//         try {
//             const data = {phoneNumber , verificationType :  "sms"}
//             const response = await sendVerificationCode(data)
//             console.log(response,'response verofcation');
//             setResp(response);

//         } catch (error) {
//             console.log(error);
//         }
//     }
//     useEffect(()=>{
//             verificationCode();
//     },[])
//   return (

//     <Modal show={show} onHide={handleClose} size="md">
//       <Modal.Header closeButton>
//         <Modal.Title className="">Phone Number Verification </Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         {
//             resp.errorCode === "Invalid Request Parameters. Please check again." ? <p>We are facing technical difficulties, please try again later.
// </p>:null
//         }
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default VerifyPhoneModal;
// import {
//   sendVerificationCode,
//   validateVerificationCode,
// } from "@/api/LoginSignup";
// import React, { useEffect, useState } from "react";
// import Modal from "react-bootstrap/Modal";
// import Button from "react-bootstrap/Button";
// import Form from "react-bootstrap/Form";
// import "./Bid.css";
// const VerifyPhoneModal = ({
//   show,
//   handleClose,
//   phoneNumber,
//   onVerificationSuccess,
// }) => {
//   const [resp, setResp] = useState({});
//   const [otpValues, setOtpValues] = useState(["", "", "", ""]);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [otpError, setOtpError] = useState("");
//   const [isResending, setIsResending] = useState(false);
//   const [resendMessage, setResendMessage] = useState("");

//   const verificationCode = async () => {
//     try {
//       const data = { phoneNumber, verificationType: "sms" };
//       const response = await sendVerificationCode(data);
//       console.log(response, "response verification");
//       setResp(response);
//     } catch (error) {
//       console.log(error);
//       setResp({ errorCode: "Error sending verification code" });
//     }
//   };

//   const handleOtpChange = (index, value) => {
//     // Only allow digits
//     if (!/^\d*$/.test(value)) return;

//     const newOtpValues = [...otpValues];
//     newOtpValues[index] = value;
//     setOtpValues(newOtpValues);

//     // Clear error when user starts typing
//     if (otpError) {
//       setOtpError("");
//     }

//     // Auto-focus next input
//     if (value && index < 3) {
//       const nextInput = document.getElementById(`otp-${index + 1}`);
//       if (nextInput) {
//         nextInput.focus();
//       }
//     }
//   };

//   const handleKeyDown = (index, e) => {
//     // Handle backspace to focus previous input
//     if (e.key === "Backspace" && !otpValues[index] && index > 0) {
//       const prevInput = document.getElementById(`otp-${index - 1}`);
//       if (prevInput) {
//         prevInput.focus();
//       }
//     }
//   };

//   const handleSubmit = async () => {
//     const otpCode = otpValues.join("");

//     if (otpCode.length !== 4) {
//       setOtpError("Please enter the complete 4-digit verification code");
//       return;
//     }

//     setIsSubmitting(true);
//     setOtpError("");

//     try {
//       const data = {
//         phoneNumber,
//         verificationCode: otpCode,
//       };

//       const response = await validateVerificationCode(data);
//       console.log(response, "validation response");

//       if (
//         response.status === "SUCCESS" &&
//         response.data?.verificationStatus === "approved"
//       ) {
//         // Success - close modal and trigger success callback
//         onVerificationSuccess();
//         handleClose();
//       } else {
//         // Failed validation
//         setOtpError("Please enter valid verification code.");
//       }
//     } catch (error) {
//       console.log(error);
//       setOtpError("Please enter valid verification code.");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleResend = async () => {
//     setIsResending(true);
//     setResendMessage("");

//     try {
//       const data = { phoneNumber, verificationType: "sms" };
//       const response = await sendVerificationCode(data);

//       if (response.status === "SUCCESS") {
//         setResendMessage("Verification code has been resent to your phone.");
//         setOtpValues(["", "", "", ""]); // Clear previous OTP
//         setOtpError("");
//       } else {
//         setResendMessage("Failed to resend code. Please try again.");
//       }
//     } catch (error) {
//       console.log(error);
//       setResendMessage("Failed to resend code. Please try again.");
//     } finally {
//       setIsResending(false);
//     }
//   };

//   const formatPhoneNumber = (phone) => {
//     if (!phone) return "";
//     const cleaned = phone.replace(/\D/g, "");
//     return `(***) - *** - ${cleaned.slice(-4)}`;
//   };

//   useEffect(() => {
//     if (show) {
//       verificationCode();
//       // Reset states when modal opens
//       setOtpValues(["", "", "", ""]);
//       setOtpError("");
//       setResendMessage("");
//     }
//   }, [show]);

//   return (
//     <Modal show={show} onHide={handleClose} size="md" backdrop="static">
//       <Modal.Header closeButton>
//         <Modal.Title>Phone Number Verification</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         {resp.errorCode ===
//         "Invalid Request Parameters. Please check again." ? (
//           <p>We are facing technical difficulties, please try again later.</p>
//         ) : (
//           <div className="verification-content">
//             <p>
//               Enter the verification code that has been sent to the phone number
//               ending in <strong>{formatPhoneNumber(phoneNumber)}</strong>
//             </p>

//             <Form.Label className="mt-3">
//               Enter the verification code below:
//             </Form.Label>

//             <div className="otp-input-container d-flex justify-content-center gap-2 my-3">
//               {otpValues.map((value, index) => (
//                 <Form.Control
//                   key={index}
//                   id={`otp-${index}`}
//                   type="text"
//                   maxLength="1"
//                   value={value}
//                   onChange={(e) => handleOtpChange(index, e.target.value)}
//                   onKeyDown={(e) => handleKeyDown(index, e)}
//                   className="otp-input text-center"
//                   style={{ width: "50px", height: "50px", fontSize: "20px" }}
//                   isInvalid={!!otpError}
//                 />
//               ))}
//             </div>

//             {otpError && (
//               <div className="text-danger text-center mb-3">{otpError}</div>
//             )}

//             {resendMessage && (
//               <div
//                 className={`text-center mb-3 ${
//                   resendMessage.includes("Failed")
//                     ? "text-danger"
//                     : "text-success"
//                 }`}
//               >
//                 {resendMessage}
//               </div>
//             )}

//             <div className="d-flex justify-content-center">
//               <Button
//                 variant="primary"
//                 onClick={handleSubmit}
//                 disabled={isSubmitting}
//                 className="px-4"
//               >
//                 {isSubmitting ? "Verifying..." : "Submit"}
//               </Button>
//             </div>

//             <div className="text-center mt-3">
//               <span>Didn't get the code? </span>
//               <Button
//                 variant="link"
//                 className="p-0 text-decoration-none"
//                 onClick={handleResend}
//                 disabled={isResending}
//               >
//                 {isResending ? "Resending..." : "Re-send via text"}
//               </Button>
//               <span> or </span>
//               <Button
//                 variant="link"
//                 className="p-0 text-decoration-none"
//                 onClick={() => {
//                   // Handle call option here if needed
//                   console.log("Call option clicked");
//                 }}
//               >
//                 receive a call instead
//               </Button>
//             </div>
//           </div>
//         )}
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default VerifyPhoneModal;
// import {
//   sendVerificationCode,
//   validateVerificationCode,
// } from "@/api/LoginSignup";
// import React, { useEffect, useState } from "react";
// import Modal from "react-bootstrap/Modal";
// import Button from "react-bootstrap/Button";
// import Form from "react-bootstrap/Form";

// const VerifyPhoneModal = ({
//   show,
//   handleClose,
//   phoneNumber,
//   onVerificationSuccess,
// }) => {
//   const [resp, setResp] = useState({});
//   const [otpValues, setOtpValues] = useState(["", "", "", ""]);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [otpError, setOtpError] = useState("");
//   const [isResending, setIsResending] = useState(false);
//   const [resendMessage, setResendMessage] = useState("");
//   const [isLoadingInitialVerification, setIsLoadingInitialVerification] =
//     useState(true);

//   const verificationCode = async () => {
//     setIsLoadingInitialVerification(true); // <-- Added this

//     try {
//       const data = { phoneNumber, verificationType: "sms" };
//       const response = await sendVerificationCode(data);
//       console.log(response, "response verification");
//       setResp(response);
//     } catch (error) {
//       console.log(error);
//       setResp({ errorCode: "Error sending verification code" });
//     } finally {
//       setIsLoadingInitialVerification(false); // <-- Added this
//     }
//   };

//   const handleOtpChange = (index, value) => {
//     // Only allow digits
//     if (!/^\d*$/.test(value)) return;

//     const newOtpValues = [...otpValues];
//     newOtpValues[index] = value;
//     setOtpValues(newOtpValues);

//     // Clear error when user starts typing
//     if (otpError) {
//       setOtpError("");
//     }

//     // Auto-focus next input
//     if (value && index < 3) {
//       const nextInput = document.getElementById(`otp-${index + 1}`);
//       if (nextInput) {
//         nextInput.focus();
//       }
//     }
//   };

//   const handleKeyDown = (index, e) => {
//     // Handle backspace to focus previous input
//     if (e.key === "Backspace" && !otpValues[index] && index > 0) {
//       const prevInput = document.getElementById(`otp-${index - 1}`);
//       if (prevInput) {
//         prevInput.focus();
//       }
//     }
//   };

//   const handleSubmit = async () => {
//     const otpCode = otpValues.join("");

//     if (otpCode.length !== 4) {
//       setOtpError("Please enter the complete 4-digit verification code");
//       return;
//     }

//     setIsSubmitting(true);
//     setOtpError("");

//     try {
//       const data = {
//         phoneNumber,
//         verificationCode: otpCode,
//       };

//       const response = await validateVerificationCode(data);
//       console.log(response, "validation response");

//       if (
//         response.status === "SUCCESS" &&
//         response.data?.verificationStatus === "approved"
//       ) {
//         // Success - close modal and trigger success callback
//         onVerificationSuccess();
//         handleClose();
//       } else {
//         // Failed validation
//         setOtpError("Please enter valid verification code.");
//       }
//     } catch (error) {
//       console.log(error);
//       setOtpError("Please enter valid verification code.");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleResend = async () => {
//     setIsResending(true);
//     setResendMessage("");

//     try {
//       const data = { phoneNumber, verificationType: "sms" };
//       const response = await sendVerificationCode(data);

//       if (response.status === "SUCCESS") {
//         setResendMessage("Verification code has been resent to your phone.");
//         setOtpValues(["", "", "", ""]); // Clear previous OTP
//         setOtpError("");
//       } else {
//         setResendMessage("Failed to resend code. Please try again.");
//       }
//     } catch (error) {
//       console.log(error);
//       setResendMessage("Failed to resend code. Please try again.");
//     } finally {
//       setIsResending(false);
//     }
//   };

//   const formatPhoneNumber = (phone) => {
//     if (!phone) return "";
//     const cleaned = phone.replace(/\D/g, "");
//     return `(***) - *** - ${cleaned.slice(-4)}`;
//   };

//   useEffect(() => {
//     if (show) {
//       verificationCode();
//       // Reset states when modal opens
//       setOtpValues(["", "", "", ""]);
//       setOtpError("");
//       setResendMessage("");
//       setIsLoadingInitialVerification(true); // <-- Added this
//     }
//   }, [show]);

//   return (
//     <Modal show={show} onHide={handleClose} size="md" backdrop="static">
//       <Modal.Header closeButton>
//         <Modal.Title>Phone Number Verification</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         {isLoadingInitialVerification ? ( // <-- Added this condition
//           <div className="text-center py-4">
//             <div className="spinner-border text-primary" role="status">
//               <span className="visually-hidden">Loading...</span>
//             </div>
//             <p className="mt-3 mb-0">Sending verification code...</p>
//           </div>
//         ) : resp.errorCode ===
//           "Invalid Request Parameters. Please check again." ? (
//           <p>We are facing technical difficulties, please try again later.</p>
//         ) : (
//           <div className="verification-content">
//             <p>
//               Enter the verification code that has been sent to the phone number
//               ending in <strong>{formatPhoneNumber(phoneNumber)}</strong>
//             </p>

//             <Form.Label className="mt-3">
//               Enter the verification code below:
//             </Form.Label>

//             <div className="otp-input-container d-flex justify-content-center gap-2 my-3">
//               {otpValues.map((value, index) => (
//                 <Form.Control
//                   key={index}
//                   id={`otp-${index}`}
//                   type="text"
//                   maxLength="1"
//                   value={value}
//                   onChange={(e) => handleOtpChange(index, e.target.value)}
//                   onKeyDown={(e) => handleKeyDown(index, e)}
//                   className="otp-input text-center"
//                   style={{ width: "50px", height: "50px", fontSize: "20px" }}
//                   isInvalid={!!otpError}
//                 />
//               ))}
//             </div>

//             {otpError && (
//               <div className="text-danger text-center mb-3">{otpError}</div>
//             )}

//             {resendMessage && (
//               <div
//                 className={`text-center mb-3 ${
//                   resendMessage.includes("Failed")
//                     ? "text-danger"
//                     : "text-success"
//                 }`}
//               >
//                 {resendMessage}
//               </div>
//             )}

//             <div className="d-flex justify-content-center">
//               <Button
//                 variant="primary"
//                 onClick={handleSubmit}
//                 disabled={isSubmitting}
//                 className="px-4"
//               >
//                 {isSubmitting ? "Verifying..." : "Submit"}
//               </Button>
//             </div>

//             <div className="text-center mt-3">
//               <span>Didn't get the code? </span>
//               <Button
//                 variant="link"
//                 className="p-0 text-decoration-none"
//                 onClick={handleResend}
//                 disabled={isResending}
//               >
//                 {isResending ? "Resending..." : "Re-send via text"}
//               </Button>
//               <span> or </span>
//               <Button
//                 variant="link"
//                 className="p-0 text-decoration-none"
//                 onClick={() => {
//                   // Handle call option here if needed
//                   console.log("Call option clicked");
//                 }}
//               >
//                 receive a call instead
//               </Button>
//             </div>
//           </div>
//         )}
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default VerifyPhoneModal;
import {
  sendVerificationCode,
  validateVerificationCode,
} from "@/api/LoginSignup";
import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

const VerifyPhoneModal = ({
  show,
  handleClose,
  phoneNumber,
  onVerificationSuccess,
}) => {
  const [resp, setResp] = useState({});
  const [otpValues, setOtpValues] = useState(["", "", "", ""]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [isResending, setIsResending] = useState(false);
  const [resendMessage, setResendMessage] = useState("");
  const [isLoadingInitialVerification, setIsLoadingInitialVerification] =
    useState(true);

  const verificationCode = async () => {
    setIsLoadingInitialVerification(true);
    try {
      const data = { phoneNumber, verificationType: "sms" };
      const response = await sendVerificationCode(data);
      // console.log(response, "response verification");
      setResp(response);
    } catch (error) {
      // console.log(error);
      setResp({ errorCode: "Error sending verification code" });
    } finally {
      setIsLoadingInitialVerification(false);
    }
  };

  const handleOtpChange = (index, value) => {
    // Only allow digits
    if (!/^\d*$/.test(value)) return;

    const newOtpValues = [...otpValues];
    newOtpValues[index] = value;
    setOtpValues(newOtpValues);

    // Clear error when user starts typing
    if (otpError) {
      setOtpError("");
    }

    // Auto-focus next input
    if (value && index < 3) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      if (nextInput) {
        nextInput.focus();
      }
    }
  };

  const handleKeyDown = (index, e) => {
    // Handle backspace to focus previous input
    if (e.key === "Backspace" && !otpValues[index] && index > 0) {
      const prevInput = document.getElementById(`otp-${index - 1}`);
      if (prevInput) {
        prevInput.focus();
      }
    }
  };

  const handleSubmit = async () => {
    const otpCode = otpValues.join("");

    if (otpCode.length !== 4) {
      setOtpError("Please enter the complete 4-digit verification code");
      setResendMessage("");
      return;
    }

    setIsSubmitting(true);
    setOtpError("");

    try {
      const data = {
        phoneNumber,
        verificationCode: otpCode,
      };

      const response = await validateVerificationCode(data);
      // console.log(response, "validation response");

      if (
        response.status === "SUCCESS" &&
        response.data?.verificationStatus === "approved"
      ) {
        // Success - close modal and trigger success callback
        onVerificationSuccess();
        handleClose();
      } else {
        // Failed validation
        setOtpError("Please enter valid verification code.");
        setResendMessage("");
      }
    } catch (error) {
      // console.log(error);
      setOtpError("Please enter valid verification code.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleResend = async (verificationType = "sms") => {
    setIsResending(true);
    setResendMessage("");
    setOtpError("");

    try {
      const data = { phoneNumber, verificationType };
      const response = await sendVerificationCode(data);

      if (response.status === "SUCCESS") {
        const message =
          verificationType === "call"
            ? "You will receive a call with the verification code shortly."
            : "Verification code has been resent to your phone.";
        setResendMessage(message);
        setOtpValues(["", "", "", ""]);
        setOtpError("");
        setResp(response);
      } else {
        const message =
          verificationType === "call"
            ? "Failed to initiate call. Please try again."
            : "Failed to resend code. Please try again.";
        setResendMessage(message);
      }
    } catch (error) {
      // console.log(error);
      const message =
        verificationType === "call"
          ? "Failed to initiate call. Please try again."
          : "Failed to resend code. Please try again.";
      setResendMessage(message);
    } finally {
      setIsResending(false);
    }
  };

  const formatPhoneNumber = (phone) => {
    if (!phone) return "";
    const cleaned = phone.replace(/\D/g, "");
    return `(***) - *** - ${cleaned.slice(-4)}`;
  };

  useEffect(() => {
    if (show) {
      verificationCode();
      // Reset states when modal opens
      setOtpValues(["", "", "", ""]);
      setOtpError("");
      setResendMessage("");
      setIsLoadingInitialVerification(true);
    }
  }, [show]);

  return (
    <Modal show={show} onHide={handleClose} size="md" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Phone Number Verification</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoadingInitialVerification ? (
          <div className="text-center py-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3 mb-0">Sending verification code...</p>
          </div>
        ) : resp.errorCode ===
          "Invalid Request Parameters. Please check again." ? (
          <p>We are facing technical difficulties, please try again later.</p>
        ) : (
          <div className="verification-content">
            <p>
              Enter the verification code that has been sent to the phone number
              ending in <strong>{formatPhoneNumber(phoneNumber)}</strong>
            </p>

            <Form.Label className="mt-3">
              Enter the verification code below:
            </Form.Label>

            <div className="otp-input-container d-flex justify-content-center gap-2 my-3">
              {otpValues.map((value, index) => (
                <Form.Control
                  key={index}
                  id={`otp-${index}`}
                  type="text"
                  maxLength="1"
                  value={value}
                  onChange={(e) => handleOtpChange(index, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  className="otp-input text-center"
                  style={{ width: "50px", height: "50px", fontSize: "20px" }}
                  isInvalid={!!otpError}
                />
              ))}
            </div>

            {otpError && (
              <div className="text-danger text-center mb-3">{otpError}</div>
            )}

            {resendMessage && (
              <div
                className={`text-center mb-3 ${
                  resendMessage.includes("Failed")
                    ? "text-danger"
                    : "text-success"
                }`}
              >
                {resendMessage}
              </div>
            )}

            <div className="d-flex justify-content-center">
              <Button
                variant="primary"
                onClick={handleSubmit}
                disabled={isSubmitting}
                className="px-4"
              >
                {isSubmitting ? "Verifying..." : "Submit"}
              </Button>
            </div>

            <div className="text-center mt-3">
              <span>Didn't get the code? </span>
              <Button
                variant="link"
                className="p-0 text-decoration-none"
                onClick={() => handleResend("sms")}
                disabled={isResending}
              >
                {isResending ? "Resending..." : "Re-send via text"}
              </Button>
              <span> or </span>
              <Button
                variant="link"
                className="p-0 text-decoration-none"
                onClick={() => handleResend("call")}
                disabled={isResending}
              >
                {isResending ? "Calling..." : "receive a call instead"}
              </Button>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default VerifyPhoneModal;
